export interface UserSetting {
    ReportName: string;
    Name: string;
    Value: string;
    SortOrder?: number;
}

export enum UserSettingReportName {
    ManualCoding = 'ManualCoding',
    UserPreference = 'UserPreference'
}

export enum UserSettingName {
    CaseDisplayOrder = 'CaseDisplayOrder',
    DataTableFontSize = 'DataTableFontSize',
    AutoSkip = 'AutoSkip',
    OrderingMethod = 'OrderingMethod',
    RespondToAgent = 'RespondToAgent',
    ForwardToClient = 'ForwardToClient'
}

export enum OrderingMethod {
    ByMatterName = 'By Matter Name',
    ByServiceCost = 'By Service Cost',
    ByTotalCost = 'By Total Cost'
}

